import { render, staticRenderFns } from "./logistic.vue?vue&type=template&id=5bb959f0&scoped=true"
import script from "./logistic.vue?vue&type=script&lang=ts"
export * from "./logistic.vue?vue&type=script&lang=ts"
import style0 from "./logistic.vue?vue&type=style&index=0&id=5bb959f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb959f0",
  null
  
)

export default component.exports